import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgClass, NgTemplateOutlet } from '@angular/common';

import { UiTranslateModule } from '@fcom/ui-translate/ui-translate.module';

import { LoaderColor, LoaderTheme } from './enums';

/**
 * This component can be used to display a loading icon with text in a variety of use cases.
 *
 * Make sure to set the theme to be the one required depending on if you need a full page or inline
 * layout.
 */
@Component({
  selector: 'fcom-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, NgTemplateOutlet, UiTranslateModule],
})
export class LoaderComponent {
  readonly LoaderTheme = LoaderTheme;

  /**
   * The theme to use for the loader.
   */
  loaderType = input<LoaderTheme>(LoaderTheme.EMBEDDED);

  /**
   * The heading tag to use above the loading icon, note that will not render with
   * LoaderTheme.INLINE or LoaderTheme.INLINE_TEXT.
   */
  title = input<string | undefined>(undefined);

  /**
   * The paragraph tag to use below the loading icon, note that will not render with
   * LoaderTheme.INLINE or LoaderTheme.INLINE_TEXT.
   */
  paragraph = input<string | undefined>(undefined);

  /**
   * The color to use with the loader. Defaults to nordic-blue-900
   */
  color = input<LoaderColor>(LoaderColor.BLUE);

  /**
   * Spacing class for the EMBEDDED theme. Defaults to 'pr-large-y'.
   * Pass empty string to remove spacing, or custom class for different spacing.
   */
  spacingClass = input<string>('pr-large-y');

  containerClass = input<string>('');
}
